import { render, staticRenderFns } from "./ContractDocumentsTab.vue?vue&type=template&id=1bfc93a7&scoped=true&"
import script from "./ContractDocumentsTab.vue?vue&type=script&lang=js&"
export * from "./ContractDocumentsTab.vue?vue&type=script&lang=js&"
import style0 from "./ContractDocumentsTab.vue?vue&type=style&index=0&id=1bfc93a7&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc93a7",
  null
  
)

export default component.exports